export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_FAIL = "FORGET_PASSWORD_FAIL";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const API_ACCOUNT_SUCCESS = "API_ACCOUNT_SUCCESS";
export const API_ACCOUNT_FAIL = "API_ACCOUNT_FAIL";

export const GENERATE_TOKEN_SUCCESS = "GENERATE_TOKEN_SUCCESS";
export const GENERATE_TOKEN_FAIL = "GENERATE_TOKEN_FAIL";

export const API_PROCESS_TRANSACTION_SUCCESS = "API_PROCESS_TRANSACTION_SUCCESS";
export const API_PROCESS_TRANSACTION_FAIL = "API_PROCESS_TRANSACTION_FAIL";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SET_RESPONSE = "SET_RESPONSE";
export const CLEAR_RESPONSE = "CLEAR_RESPONSE";

export const SET_TOKEN = "SET_TOKEN";
export const CLEAR_TOKEN = "CLEAR_TOKEN";

export const VALIDATE_CONCURRENT_LOGIN_SUCCESS = "VALIDATE_CONCURRENT_SUCCESS";
export const VALIDATE_CONCURRENT_LOGIN_FAIL = "VALIDATE_CONCURRENT_FAIL"

export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS";
export const ADD_CONTACT_FAIL = "ADD_CONTACT_FAIL";

export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";

export const GET_RECAPTCHA_SITE_KEY = "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx";